import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c2f1c9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import { Component } from "vue";
import { XCircleIcon } from "@heroicons/vue/solid";


export default /*#__PURE__*/_defineComponent({
  props: {
    isOpen: null,
    actions: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["action-menu", { hidden: !__props.isOpen }])
  }, [
    _createVNode(_unref(XCircleIcon), {
      href: "#",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
      class: "w-8 h-8 cursor-pointer hover:text-red-700 text-red-500 p-1 absolute -top-4 -right-4"
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.actions, (action) => {
      return (_openBlock(), _createElementBlock("button", {
        key: action.text,
        onClick: ($event: any) => (action.action()),
        class: "p-4 space-x-4 w-full flex items-center text-gray-800 text-lg hover:bg-gray-100"
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(action.icon), {
          class: _normalizeClass(["w-5 h-5", [action.iconColor]])
        }, null, 8, ["class"])),
        _createElementVNode("p", null, _toDisplayString(action.text), 1)
      ], 8, _hoisted_1))
    }), 128))
  ], 2))
}
}

})